import React from "react";
import TimeTargetProgress from "./TimeTargetProgress";
import SimpleTimeTargetProgress from "./SimpleTimeTargetProgress";

const ProgressFactory = ({ progressApproach = 'STANDARD', targetProgress, timeProgress,
    showCalendarProgress = true, showTargetProgress = true, className = null, locale = null
}) => {
    
    switch (progressApproach) {
        case 'STANDARD':
            return (
                <TimeTargetProgress targetProgress={targetProgress} timeProgress={timeProgress}
                    showCalendarProgress={showCalendarProgress} showTargetProgress={showTargetProgress} className={className}
                />
            );
        case 'SIMPLE':
            return (
                <SimpleTimeTargetProgress targetProgress={targetProgress} timeProgress={timeProgress}
                    showCalendarProgress={showCalendarProgress} showTargetProgress={showTargetProgress} className={className}
                    locale={locale}
                />
            );
        default:
            return (
                null
            );
    }

}

export default ProgressFactory;